<ng-container
  *ngIf="{
    title: title$ | async,
		isBackButtonVisible: isBackButtonVisible,
		backButtonTitle: backButtonTitle,
		backButtonRedirectPage: backButtonRedirectPage,
		pageTitle: pageTitle		
  } as content"
>
	<div class="title-container">
		<h1 class="page-title {{ classList }}">
			{{ pageTitle ? pageTitle : content.title }}
		</h1>
		<a [routerLink]="['/my-account', content.backButtonRedirectPage]" class="text-underline back-link" *ngIf="content.isBackButtonVisible" >
			{{ content.backButtonTitle }}
		</a>
	</div>
</ng-container>
